import { SSRThemeProvider as o } from "./ssrthemeprovider.js";
export {
  o as SSRThemeProvider
};
